import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { YoungAdultPaxComponent } from './young-adult-pax.component';

@NgModule({ declarations: [YoungAdultPaxComponent],
    exports: [YoungAdultPaxComponent], imports: [CommonModule, ModalModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class YoungAdultPaxModule {}
